import { func_validation } from "./func_validation";



export const func_currency = {

    price_toNearestFiveCent,
    commafy,

	validateStringDoublePrecisionCurrency,

};

function price_toNearestFiveCent(price) {
    let price_formatted = parseFloat(price);
    let price_remainder = parseFloat((price_formatted % 0.05).toFixed(2));
    if (price_remainder !== 0) {
        // not distributable in 5 cents unit
        if (price_remainder <= 0.02) price_formatted -= price_remainder;
        else if (price_remainder <= 0.05) price_formatted += (0.05 - price_remainder);
    }
    return price_formatted;
}

function commafy(str, thousandSeparatorInterval, thousandSeparator, decimalSeparator) {
    // split
    let str_formatted = str.toString().split(".");
    let int_formatted = (func_validation.isNotNullUndefined(thousandSeparatorInterval))?parseInt(thousandSeparatorInterval):3;
    if (!func_validation.isNumberValid(int_formatted)) int_formatted = 3;
    
    let intMax_formatted = int_formatted + 1;

    if (str_formatted[0].length >= intMax_formatted) {
        let regexStr = "(\\d)(?=(\\d{"+int_formatted+"})+$)";
        let re = new RegExp(regexStr,"g");
        str_formatted[0] = str_formatted[0].replace(re, "$1"+thousandSeparator);
    }

    // rejoin
    return str_formatted.join(decimalSeparator);
}

function validateStringDoublePrecisionCurrency(value, minValue) {
	let value_formatted = value;
	let minValue_formatted = (minValue)?minValue:"1.00";

	// remove 0 in front
	while (typeof value_formatted === "string" && 
		   (value_formatted.charAt(0) === "0" && value_formatted.charAt(1) !== ".")) {
		   value_formatted = value_formatted.substr(1);
	}
	
	// handle empty or 0 values
	if (!value_formatted || 
		value_formatted == "0" || value_formatted == "0." || value_formatted == "0.0" || value_formatted == "0.00") 
		value_formatted = minValue_formatted;

	// append decimals
	if (!(~value_formatted.indexOf("."))) value_formatted += ".00";
	if (value_formatted.substr(-1,1) == ".") value_formatted += "00";
	if (value_formatted.substr(-2,1) == ".") value_formatted += "0";
	if (value_formatted.charAt(0) == ".") value_formatted = "0"+value_formatted;
	
	return value_formatted;
}


